import * as ko from "knockout";

ko.components.register('extra-notes', {
	viewModel: function(params) {
		this.data = ko.observable(params.data);
		this.content_class = params.content_class ?? '';
		// Honor newlines by default; appended caller CSS can extend or override.
		this.content_style = 'white-space: break-spaces;' + (params.content_style ?? '');
	},
	template:
		`<!-- ko with: data -->
		<div class="d-flex justify-content-between align-items-start" data-bind="if: !editing_extra_notes()">
			<span data-bind="text: extra_notes, css: $component.content_class, attr: { style: $component.content_style }"></span>
			<button class="btn btn-sm btn-link mdi mdi-18px mdi-notebook-edit p-0 lh-1" data-bind="click: () => {new_extra_notes(extra_notes()); editing_extra_notes(true)}"></button>
		</div>
		<div data-bind="if: editing_extra_notes()">
			<textarea class="w-100" data-bind="value: new_extra_notes" style="min-height: 120px"></textarea>
			<div class="d-flex gap-1">
				<button class="btn btn-sm btn-danger w-100" data-bind="click: cancel_extra_notes">Cancel</button>
				<button class="btn btn-sm btn-primary w-100" data-bind="click: save_extra_notes">Save</button>
			</div>
		</div>
		<!-- /ko -->`
});